export default class DependentLocation {
  localSelect() {
    const locale_group = gon.locale_group;

    function _nullOption(text) {
      return `<option value=''>${text}</option>`
    }

    $(document).ready(function () {
      $(document).on('change', '.select-dependent', function () {
        let location_type = $(this).data('role');

        let ele_area = $(this).parents('.gr-select-dependent').find('.select-dependent[data-role="area"]');
        let ele_country = $(this).parents('.gr-select-dependent').find('.select-dependent[data-role="country"]');
        let ele_city = $(this).parents('.gr-select-dependent').find('.select-dependent[data-role="city"]');
        let ele_town = $(this).parents('.gr-select-dependent').find('.select-dependent[data-role="town"]');

        let exclude_jp = $(this).parents('.gr-select-dependent').find("#select_country").attr('exclude_jp');
        if (exclude_jp != null && exclude_jp.toLowerCase() == 'true') {   // remove japan if current_company was working onboard
          locale_group[0].countries.splice(locale_group[0].countries.findIndex(function(i) {
            return i.id == 102;
          }), 1);
        }

        if (location_type === 'area') {
          ele_country.html(_nullOption(gon.views.shared.Country));
          ele_city.html(_nullOption(gon.views.shared.City));
          ele_town.html(_nullOption(gon.views.shared.Town));
          ele_town.hide();
          if ($(this).val() !== '') {
            let area = locale_group.filter(area => area.id.toString() === $(this).val())[0];
            ele_country.html(
              _nullOption(gon.views.shared.prompt.all) +
              area.countries.map(country => `<option value="${country.id}">${country.description}</option>`).join('')
            );
            ele_city.html(_nullOption(gon.views.shared.prompt.all));
          }
        } else if (location_type === 'country') {
          ele_city.html(`${_nullOption(gon.views.shared.prompt.all)}${_nullOption('---')}`);
          ele_town.html(_nullOption(gon.views.shared.Town));
          ele_town.hide();
          if ($(this).val() !== '') {
            let area = locale_group.filter(area => area.id.toString() === $(ele_area).val())[0];
            let country = area.countries.filter(country => country.id.toString() === $(this).val())[0];
            ele_city.html(
              _nullOption(gon.views.shared.prompt.all) +
              country.cities.map(city => `<option value="${city.id}">${city.description}</option>`).join('')
            )
          }
        } else if (location_type === 'city') {
          ele_town.html(_nullOption(gon.views.shared.Town));
          ele_town.show();
          if ($(this).val() !== '') {
            let area = locale_group.filter(area => area.id.toString() === $(ele_area).val())[0];
            let country = area.countries.filter(country => country.id.toString() === $(ele_country).val())[0];
            let city = country.cities.filter(city => city.id.toString() === $(ele_city).val())[0];
            if (city.towns.length > 0) {
              $(ele_town).parents('.ele-towns').show();
              ele_town.html(
                _nullOption(gon.views.shared.Town) +
                city.towns.map(town => `<option value="${town.id}">${town.description}</option>`).join('')
              )
            } else {
              $(ele_town).parents('.ele-towns').hide();
            }
          }
        }
      })
    })

    $(document).ready(function () {
      $(document).on('click', '.select-only-japan', function () {

        let ele_area = $(this).parents('.modal-body').find('.select-dependent[data-role="area"]');
        let ele_country = $(this).parents('.modal-body').find('.select-dependent[data-role="country"]');

        if ($(this).is(":checked")) {
          ele_area.val(gon.views.shared.asia_location_code).change()
          ele_country.val(gon.views.shared.japan_location_code).change()
        } else {
          ele_area.val('').change()
        }
      })
    })


  }
}
